// Helpers to request phone-sized, WebP variants of admin-uploaded images.
// Only our own /api/public/blog-image/ route supports resizing; every other
// URL (bundled assets, external images) is returned untouched.

const RESIZABLE_PREFIX = "/api/public/blog-image/";

export const RESPONSIVE_WIDTHS = [320, 480, 640, 768, 960, 1200, 1600] as const;

export function isResizable(url: string | null | undefined): boolean {
  if (!url) return false;
  return url.startsWith(RESIZABLE_PREFIX) || url.includes(RESIZABLE_PREFIX);
}

/** Same image, rendered at (at most) `width` CSS pixels. */
export function sizedImageUrl(url: string, width: number, quality?: number): string {
  if (!isResizable(url)) return url;
  const sep = url.includes("?") ? "&" : "?";
  const q = quality ? `&q=${quality}` : "";
  return `${url}${sep}w=${width}${q}`;
}

/** `srcset` string so browsers can pick the smallest usable file. */
export function imageSrcSet(
  url: string,
  widths: readonly number[] = RESPONSIVE_WIDTHS,
  quality?: number,
): string | undefined {
  if (!isResizable(url)) return undefined;
  return widths.map((w) => `${sizedImageUrl(url, w, quality)} ${w}w`).join(", ");
}
